module.exports = __webpack_public_path__ + "img/red-menace-logo-transparent.1fa2d323.png";